'use client';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth/auth-context';
import { useRouter } from 'next/navigation';

export default function HomeHeader() {
  const { user } = useAuth();
  const router = useRouter();

  const navigateToLogin = () => {
    router.push('/login');
  };

  const navigateToSignup = () => {
    router.push('/signup');
  };

  return (
    <header className="w-full bg-background/10 backdrop-blur-sm border-b border-border/40 sticky top-0 z-50">
      <div className="container mx-auto px-6 py-1">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-center space-x-2">
            <Image
              src="https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/dark-full.png"
              alt="MenuMate"
              width={150}
              height={32}
              className="dark:invert"
              priority
            />
          </Link>

          {/* Navigation */}
          {/* <nav className="hidden md:flex items-center space-x-8">
            <Link href="/about" className="text-muted-foreground hover:text-foreground transition-colors">
              About
            </Link>
            <Link href="#features" className="text-muted-foreground hover:text-foreground transition-colors">
              Features
            </Link>
            <Link href="#pricing" className="text-muted-foreground hover:text-foreground transition-colors">
              Pricing
            </Link>
            <Link href="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
              Contact
            </Link>
          </nav> */}

          {/* Auth Buttons */}
          <div className="flex items-center space-x-4">
            {user ? (
              <Link href="/orders">
                <Button variant="default" className="rounded-full">
                  Go to Application
                </Button>
              </Link>
            ) : (
              <>
                <Button 
                  variant="ghost" 
                  onClick={navigateToLogin}
                  className="rounded-full"
                >
                  Login
                </Button>
                <Button 
                  variant="green" 
                  onClick={navigateToSignup}
                  className="hidden sm:inline-flex rounded-full"
                >
                  Start for free
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}